import * as CRC from '../CRC';

type Percentage = number;

export function decode(packet: Uint8Array): Percentage {
  CRC.verify(packet);
  return packet[1];
}
